import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { I18nService } from '@gruposaltaedu/liv-i18n/core';
import { map } from 'rxjs/operators';

import { ConnectionService } from '../../services/connection.service';

export const offlineGuard: CanMatchFn = () => {
  const i18n = inject(I18nService);
  const router = inject(Router);
  const connectionService = inject(ConnectionService);

  return connectionService.connected$.pipe(
    map((isConnected) => {
      if (!isConnected) {
        return router.parseUrl('/' + i18n.currentLanguage() + '/offline');
      }
      return true;
    })
  );
};
